var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "-mx-3 py-2 px-4 bg-blue-400 flex justify-between items-center lg:mx-0",
    },
    [
      _c("div", { staticClass: "flex items-center gap-4" }, [
        _c(
          "p",
          {
            staticClass:
              "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6 hidden lg:block",
          },
          [_vm._v(_vm._s(_vm.$t("testBank.limit")))]
        ),
        _c("div", { staticClass: "flex items-center" }, [
          _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c("GrmTextField", {
                staticClass: "w-14 mr-1 flex",
                attrs: {
                  type: "number",
                  textalign: "right",
                  size: "2xs",
                  min: 0,
                  max: 23,
                },
                model: {
                  value: _vm.hours,
                  callback: function ($$v) {
                    _vm.hours = $$v
                  },
                  expression: "hours",
                },
              }),
              _c("p", { staticClass: "text-sm text-white" }, [
                _vm._v(_vm._s(_vm.$t("common.hour"))),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ml-3 flex items-center" },
            [
              _c("GrmTextField", {
                staticClass: "w-14 mr-1 flex",
                attrs: {
                  type: "number",
                  textalign: "right",
                  size: "2xs",
                  min: 0,
                  max: 59,
                },
                model: {
                  value: _vm.minutes,
                  callback: function ($$v) {
                    _vm.minutes = $$v
                  },
                  expression: "minutes",
                },
              }),
              _c("p", { staticClass: "text-sm text-white" }, [
                _vm._v(_vm._s(_vm.$t("common.minute"))),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ml-3 flex items-center" },
            [
              _c("GrmTextField", {
                staticClass: "w-14 mr-1 flex",
                attrs: {
                  type: "number",
                  textalign: "right",
                  size: "2xs",
                  min: 0,
                  max: 59,
                },
                model: {
                  value: _vm.seconds,
                  callback: function ($$v) {
                    _vm.seconds = $$v
                  },
                  expression: "seconds",
                },
              }),
              _c("p", { staticClass: "text-sm text-white" }, [
                _vm._v(_vm._s(_vm.$t("common.second"))),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("GrmBtn", { on: { click: _vm.onStartExam } }, [
        _vm._v(_vm._s(_vm.$t("common.start"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }